<template>
  <div :class="classes">
    <div
      class="color-indicator__color"
      :style="{ '--color-indicator-color': color }"
    />
    <EIcon
      v-show="!active && showPlus"
      class="color-indicator__icon color-indicator__icon--plus"
      icon="plus"
      :size="size"
    />
    <EIcon
      v-show="active"
      class="color-indicator__icon color-indicator__icon--check"
      icon="check-circle"
      :color="color"
      :size="size"
    />
  </div>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';
import EIcon, { sizes } from '~~/common/vue/components/icon';

export { sizes };

export default {
  name: 'EColorIndicator',
  components: {
    EIcon,
  },
  mixins: [classes],
  props: {
    active: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
    color: {
      type: String,
      required: true,
      cssClass: true,
    },
    darkIcons: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
    showPlus: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    size: EIcon.props.size,
  },
};
</script>

<style lang="scss" scoped>
$sizes: (
  s: 16px,
  m: 22px,
);

.color-indicator {
  border-radius: $border-radius-full;
  color: white;
  overflow: hidden;
  position: relative;

  @each $name, $size in $sizes {
    &--size-#{$name} {
      width: $size;
      height: $size;
    }
  }
}

.color-indicator__color {
  background: var(--color-indicator-color);
  height: 100%;
  width: 100%;
}

.color-indicator__icon {
  color: white;
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.color-indicator__icon--plus {
  opacity: 0;
  transition: opacity $timing-2s;

  .color-indicator:hover &,
  .color-indicator:focus & {
    opacity: 1;
  }
}

// Not using semantic colors here
// This color is used regardless of theme
.color-indicator--dark-icons .color-indicator__icon {
  color: $c-gray-50;
}
</style>
